/* eslint-disable @typescript-eslint/camelcase */
import { call, put, all, takeLatest } from 'redux-saga/effects'
import { fetchProfiles } from '../../api/profile'
import { ProfileActions, FETCH_PROFILES } from './actions'

export function* loadProfiles(action: ReturnType<typeof ProfileActions.fetchAllProfiles>) {
  try {
    const { limit, offset, sid } = action.payload
    const { data } = yield call(fetchProfiles, limit, offset, sid)
    yield put(ProfileActions.fetchProfilesSuccess(data))
  } catch (err) {
    // eslint-disable-next-line no-console
    yield console.log(err)
  }
}

export function* rootSaga() {
  yield all([takeLatest(FETCH_PROFILES, loadProfiles)])
}
